// Colored left-bar section heading for the Status Sheet. color: one of
// blue | green | amber | purple (fixed per section, decided in the design spec).
const BAR = {
  blue: "border-blue-600",
  green: "border-emerald-600",
  amber: "border-amber-500",
  purple: "border-violet-600",
};

export default function SectionHeader({ color, title, count, subtitle }) {
  return (
    <div className={`border-l-[3px] ${BAR[color] || BAR.blue} pl-2.5 mb-2.5 flex items-baseline gap-2`}>
      <h3 className="text-sm font-bold text-slate-900">{title}</h3>
      {subtitle && <span className="text-xs text-slate-500">{subtitle}</span>}
      {count != null && <span className="text-xs text-slate-400">· {count}</span>}
    </div>
  );
}
